<div id="bubble" #bubble>
    <p *ngIf="!bubbleData.length" class="mt">No Data</p>
</div>